import { useTranslation } from "react-i18next";
import { Switch, Col, Row, Menu, Dropdown, Button } from "antd";
import { MoreHorizontal } from "react-feather";

import { IConplaintCategory, IConplaintCategoryName } from "@interfaces";
import { orgApi } from "@api";
import { enumNewsType } from "@configs";
import { getConplaintCategories, selectAuth, setLoading } from "@redux";
import { useDispatch, useSelector } from "react-redux";
import { IconDrag } from "@components";
import { useNotify } from "@utils";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
interface IProps {
    item: IConplaintCategory;
    itemJson: string;
    index: number;
    newType?: enumNewsType;
    editCategory: (params: IConplaintCategory) => void;
}

export const ComponentRowCategory = (props: IProps) => {
    //hooks
    const { t } = useTranslation();
    const { success, error } = useNotify();
    const organization_id = useSelector(selectAuth).auth?.organization_data?._id;
    const adminId = useSelector(selectAuth).auth?.admin_data?._id;
    const { item, itemJson, editCategory } = props;
    const dispatch = useDispatch();
    const { attributes, listeners, setNodeRef, transform } = useSortable({
        id: itemJson,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
    };

    const handleDelete = async () => {
        dispatch(setLoading(true));
        try {
            const { data } = await orgApi.deleteConplainCat({
                organization_id: organization_id || "",
                complain_category_id: item._id || "",
            });
            if (data.error === "0") {
                success(data.msg);
                dispatch(
                    getConplaintCategories({
                        organization_id: organization_id || "",
                        admin_id: adminId || "",
                    })
                );
                dispatch(setLoading(false));
            } else {
                error(data.msg);
                dispatch(setLoading(false));
            }
        } catch (err: any) {
            dispatch(setLoading(false));
        }
    };

    const menu = (
        <Menu>
            <Menu.Item key={1} onClick={handleDelete}>
                <div className="duplicate-btn">{t("page.delete")}</div>
            </Menu.Item>
        </Menu>
    );
    const handleUpdateStatus = async (e: boolean) => {
        dispatch(setLoading(true));
        try {
            const { data } = await orgApi.setEnableComplainCategory({
                organization_id: organization_id || "",
                complain_category_id: item._id || "",
                is_enable: e,
            });
            if (data.error === "0") {
                success(data.msg);
                dispatch(
                    getConplaintCategories({
                        organization_id: organization_id || "",
                        admin_id: adminId || "",
                    })
                );
                dispatch(setLoading(false));
            } else {
                success(data.msg);
                dispatch(setLoading(false));
            }
        } catch (err: any) {
            dispatch(setLoading(false));
        }
    };
    const getCategoryName = (params: IConplaintCategoryName[]) => {
        if (params.length === 0) return "-";
        const res = params.reduce((acc: string[], cur: IConplaintCategoryName) => {
            acc.push(cur.division_name);
            return acc;
        }, []);
        return res.toString();
    };
    return (
        <div className="table-element" ref={setNodeRef} style={style}>
            <div className="drag-icon" {...attributes} {...listeners}>
                <IconDrag />
            </div>
            <div className="table-row">
                <Row
                    style={{ height: "100%" }}
                    gutter={24}
                    type="flex"
                    align="middle"
                    justify="space-between"
                >
                    <Col className="col-item" span={8}>
                        <p className="row-name" onClick={() => editCategory(item)}>
                            {item.category_name || t("page.empty_text")}
                        </p>
                    </Col>
                    <Col className="col-item" span={8}>
                        {getCategoryName(item.division_data_list)}
                    </Col>
                    <Col className="col-item" span={4}>
                        <Switch onChange={handleUpdateStatus} checked={item.is_enable} />
                    </Col>
                    <Col className="option-dropdown" span={4}>
                        <Dropdown
                            //@ts-ignore
                            getPopupContainer={(trigger) => trigger.parentNode}
                            overlay={menu}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <Button style={{ border: "unset" }}>
                                <MoreHorizontal />
                            </Button>
                        </Dropdown>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
